export default "__VITE_ASSET__9862d7d7__"